<ng-content></ng-content>
<div *ngFor="let cartItem of sortedCartItems" class="margin-b-5">
  <h3 *ngIf="cartItem.products.length > 0">
    <strong>{{ "cart.collection" | i18next }}</strong>
    {{
      this.collectionsService.getCollectionData(cartItem.collectionId).texts
        .title | i18next
    }}
  </h3>
  <div class="product-list grid grid-gap-big">
    <ng-container *ngFor="let cartItem of cartItem.products">
      <div
        class="xs-6 m-4 l-3 product-card no-cursor"
        [ngClass]="{
          'sku-missing': highlightSkus?.includes(cartItem.product.sku),
          'sku-transfered': transferedSkus?.includes(cartItem.product.sku)
        }"
      >
        <div class="img-wrapper">
          <div class="quantity">
            <span>{{ cartItem.quantity }}<small>x</small></span>
          </div>
          <img
            src="{{ cartItem.product.images.freestanding_1 | image }}"
            loading="lazy"
          />
        </div>
        <div class="product-info-box">
          <h2 class="flex-container">
            {{ cartItem.product.texts.caption | i18next }}
          </h2>
          <div *ngIf="priceActive" class="price">
            <span class="line"> </span>
            {{
              cartItem.product.price
                | currency
                  : collectionsService.currencyCode
                  : currencySymbol
                  : "2.2-2"
                  : "de"
            }}
            <div
              *ngIf="transferedSkus?.includes(cartItem.product.sku)"
              class="transfered"
            >
              <img
                class="my-auto"
                src="./assets/img/checkmark-circle-green.svg"
              />
              <small class="my-auto xs-hidden transferred-message">{{
                "cart.b2b.successfull-item" | i18next
              }}</small>
            </div>
          </div>
          <app-product-edit [cartItem]="cartItem"></app-product-edit>
        </div>
      </div>
    </ng-container>
  </div>
</div>
